<template>
  <div id="index-list" :style="{ background: this.color }">
    <div
      class="index-box"
      :style="currentSlideStyle(currentSlide, el.name)"
      :key="index + 'indexOfElement'"
      v-for="(el, index) in indexList"
      @click="setSlide(el.name, el.index)"
    >
      <span>
        <div class="slide-number" :style="{ color: contrastColor }">{{ index + 1 }}</div>
        <i :style="{ color: contrastColor }">{{ el.name }}</i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index-list',
  components: {},
  props: {
    indexs: {
      default: function () {
        return [];
      },
      type: Array,
    },
    color: {
      default: function () {
        return '#0054a3';
      },
      type: String,
    },
    contrastColor: {
      default: function () {
        return 'white';
      },
      type: String,
    },
  },
  data() {
    return {
      indexList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    setSlide(id, index) {
      this.$emit('setstep', id, index);
    },
    currentSlideStyle(slide, name) {
      return slide == name
        ? {
            transform: 'translateX(10%)',
            // 'border-top': 'calc(1080px * 0.01) solid ' + this.color,
            // 'border-bottom': 'calc(1080px * 0.01) solid ' + this.color,
            // 'border-right': 'calc(1920px * 0.05) solid ' + this.color,
            // margin: 'calc(1080px * 0.01)',
            // background: '#ffffff10',
          }
        : {
            // 'border-top': 'calc(1080px * 0.01) solid white',
            // 'border-bottom': 'calc(1080px * 0.01) solid white',
            // 'border-right': 'calc(1920px * 0.05) solid white',
            background: '#ffffff30',
          };
    },
    init() {
      console.log(this.indexs);
      this.indexList = [];
      this.indexs.forEach((el, index) => {
        if (el.id != 'skip') this.indexList.push({ name: el.id, index: index });
      });
    },
  },
  computed: {
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '../../style/base'
#index-list
  // background: white
  top: calc(1080px * 0.05)
  right: 0
  position: fixed
  z-index: 1
  max-height: calc(1080px * 0.4)
  overflow-y: scroll
  overflow-x: hidden
  font-size: 1.3rem
  color: white
  .index-box
    width: 100%
    border-top: calc(1080px * 0.01) solid transparent
    border-bottom: calc(1080px * 0.01) solid transparent
    border-right: calc(1920px * 0.05) solid transparent
    background: transparent
    text-align: left
    transition: .5s
    cursor: pointer
    .slide-number
      width: calc(1920px * 0.04)
      text-align: center
      display: inline-block
    &:hover
      transform: translateX(6%)

.index-fade-leave-active, .index-fade-enter-active, .info-fade-leave-active, .info-fade-enter-active, .translate-x-fade-leave-active, .translate-x-fade-enter-active, .rotate-fade-leave-active, .rotate-fade-enter-active, .skew-x-fade-leave-active, .skew-x-fade-enter-active
  transition: all .5s linear

.info-fade-leave-to, .info-fade-enter
  transform: scale(0,0)
  opacity: 0

.index-fade-leave-to, .index-fade-enter
  transform: translateX(100%)
  opacity: 0

.rotate-fade-leave-to, .rotate-fade-enter
  transform: rotate(15deg)
  opacity: 0

.translate-x-fade-leave-to, .translate-x-fade-enter
  transform: translateX(calc(1920px * 0.1))
  opacity: 0

.skew-x-fade-leave-to, .skew-x-fade-enter
  transform: skewX(20deg)
  opacity: 0

.rotate-fade-enter-active, .info-fade-enter-active, .skew-x-fade-enter-active, .translate-x-fade-enter-active
  transition-delay: .5s

#index-list::-webkit-scrollbar-track
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
  background-color: white

#index-list::-webkit-scrollbar
  width: 10px
  background-color: white

#index-list::-webkit-scrollbar-thumb
  background-color: gray
  border: 2px solid gray
</style>
